export const USER_SETTINGS_LABELS = {
    first_name: 'Vorname',
    last_name: 'Nachname',
    salutation: 'Anrede',
    job_title: 'Rolle',
    phone_number: 'Telefonnummer',
    team: 'Team',
    header: 'Persönliches Profil',
    email: 'E-Mail Adresse',
    logout: 'Abmelden',
    certification: 'Zertifizierung',
    locale: 'Sprache',
}

export const USER_SETTINGS_COPY = {
    labels: USER_SETTINGS_LABELS,
    salutationOptions: [
        { label: 'Keine Anrede', value: '-' },
        { label: 'Herr', value: 'Herr' },
        { label: 'Frau', value: 'Frau' },
        { label: 'Herr Dr.', value: 'Herr Dr.' },
        { label: 'Frau Dr.', value: 'Frau Dr.' },
    ],
    teamSectionTitle: 'Team',
    invalidPhoneNumberMessage: 'Keine gültige Telefonnummer',
    teamRequiredMessage: 'Pflichtfeld',
    discardChangesDialogTitle: 'Alle ungespeicherten Änderungen verwerfen?',
    discardChangesConfirmLabel: 'Verwerfen',
    discardChangesCancelLabel: 'Abbrechen',
    modal: {
        profileImageLabel: 'Profilbild',
        uploadImageLabel: 'Hochladen',
        removeImageLabel: 'Entfernen',
        removeImageConfirmation: {
            title: 'Profilbild entfernen?',
            message: 'Ihr Profilbild wird dauerhaft entfernt. Möchten Sie fortfahren?',
            cancelLabel: 'Abbrechen',
        },
        rowLabels: {
            job_title: 'Rolle',
            phone_number: 'Telefon',
            team: 'Team',
            email: 'E-Mail',
            certification: 'Zertifizierung',
            locale: 'Sprache',
        },
    },
}

export const USER_SETTINGS_HEADER_COPY = {
    header: USER_SETTINGS_LABELS.header,
    logout: USER_SETTINGS_LABELS.logout,
    headerImageAlt: 'generic header image',
    userImageAlt: 'User Image',
    uploadImageAriaLabel: 'upload-image',
}

export const PADDING_X = '15%'
